import { css } from '@emotion/core'
import { GatsbyImage } from 'gatsby-plugin-image'
import React from 'react'

import Block from './Block'
import { Link } from './Link'

type ProductHeroResourceProps = {
  author?: string
  imageSrc: any
  imgAlt: string
  title: string
  link?: string
  abstract?: string
  tags?: { name: string }[]
}

export const ProductHeroResource: React.FC<ProductHeroResourceProps> = ({
  imageSrc,
  imgAlt,
  title,
  author,
  abstract,
  tags,
  link,
}) => {
  return (
    <Link href={link} rel="nofollow" className="opacity-on-hover">
      <Block columns={2} columnsTemplate="auto 1fr" noBreakForTablet alignContent="flex-start">
        <GatsbyImage
          image={imageSrc.gatsbyImageData}
          alt={imgAlt}
          imgStyle={{ height: '92px', borderRadius: '0.5rem' }}
        />
        <div>
          {author && <div className="body-2 white-text">{author}</div>}
          <div className="strong-body-1 white-text" data-title>
            {title}
          </div>
          {abstract && <div className="body-1 white-text">{abstract}</div>}
          <div css={tagsContainerStyle}>
            {tags?.map(({ name }) => (
              <div key={`product-hero-tag-${name}`} className="body-2 white-text" css={tagStyle}>
                {name}
              </div>
            ))}
          </div>
        </div>
      </Block>
    </Link>
  )
}

const tagsContainerStyle = css`
  margin-top: 0.5rem;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.25rem 0.5rem;
`

const tagStyle = css`
  padding: 0.15rem 0.5rem;
  border-radius: 0.5rem;
  background: rgba(255, 255, 255, 0.1);
`
